import { IMealItem } from '~/types/combo';
import { IProductV4 } from '~/types/product';

export const transformToMealItem = (item: IProductV4, size_id: number, group_id: number, choice_id: number): IMealItem => {
  return {
    ...item,
    product_price: item.price,
    size_id,
    group_id,
    choice_id,
  };
};
